import React from 'react';
import { getText } from 'services/languageService';
import { YearSelectProps } from 'types/mainPage';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export const YearSelect: React.FC<YearSelectProps> = ({
  handleChangeYear,
  years,
  currentYear,
}) => {
  return (
    <Box sx={{ p: 2, pb: 0.5 }}>
      <FormControl fullWidth size={'small'}>
        <InputLabel id="demo-select-small-label">{getText('YEAR')}</InputLabel>
        <Select
          value={currentYear}
          onChange={handleChangeYear}
          label={getText('YEAR')}
          labelId="demo-select-small-label"
          id="demo-select-small"
        >
          {years.map((year, index) => {
            return (
              <MenuItem key={year + index} value={year}>
                {year}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};
